import _objectSpread2 from "../_virtual/_@oxc-project_runtime@0.143.0/helpers/esm/objectSpread2.js";
import { initializeUserActionsAPI } from "./userActions/initialize.js";
import { initializeEventsAPI } from "./events/initialize.js";
import { initializeExceptionsAPI } from "./exceptions/initialize.js";
import { initializeLogsAPI } from "./logs/initialize.js";
import { initializeMeasurementsAPI } from "./measurements/initialize.js";
import { initializeMetaAPI } from "./meta/initialize.js";
import { initializeTracesAPI } from "./traces/initialize.js";
//#region src/api/initialize.ts
function initializeAPI(unpatchedConsole, internalLogger, config, metas, transports) {
	internalLogger.debug("Initializing API");
	let pushEventImpl = null;
	const pushEventWrapper = (name, attributes, domain, options) => {
		if (pushEventImpl) pushEventImpl(name, attributes, domain, options);
		else internalLogger.warn("pushEventImpl is not initialized. Event dropped:", {
			name,
			attributes,
			domain,
			options
		});
	};
	const userActionsApi = initializeUserActionsAPI({
		transports,
		config,
		internalLogger,
		pushEvent: pushEventWrapper
	});
	const tracesApi = initializeTracesAPI(unpatchedConsole, internalLogger, config, metas, transports);
	const props = {
		unpatchedConsole,
		internalLogger,
		userActionsApi,
		config,
		metas,
		transports,
		tracesApi
	};
	const eventsApi = initializeEventsAPI(props);
	pushEventImpl = eventsApi.pushEvent;
	return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, tracesApi), initializeExceptionsAPI(props)), initializeMetaAPI(props)), initializeLogsAPI(props)), initializeMeasurementsAPI(props)), eventsApi), userActionsApi);
}
//#endregion
export { initializeAPI };

//# sourceMappingURL=initialize.js.map